module.exports = __webpack_public_path__ + "static/img/tit09.ada1ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tit09.png
// module id = RuHg
// module chunks = 0